import ContactContainer from './Contact';

export default ContactContainer;
